import { questionConstants } from "../constants/questionConstants";
import { questionService } from "../../services/API/questionService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const add_question = postData => {
  return dispatch => {
    dispatch(request());
    questionService.add_question(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: questionConstants.ADD_QUESTION_REQUEST, data };
  }
  function success(data) {
    return { type: questionConstants.ADD_QUESTION_SUCCESS, data };
  }
  function failure(error) {
    return { type: questionConstants.ADD_QUESTION_FAILURE, error };
  }
};

export const add_answer = postData => {
  return dispatch => {
    dispatch(request());
    questionService.add_answer(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: questionConstants.ADD_ANSWER_REQUEST, data };
  }
  function success(data) {
    return { type: questionConstants.ADD_ANSWER_SUCCESS, data };
  }
  function failure(error) {
    return { type: questionConstants.ADD_ANSWER_FAILURE, error };
  }
};

export const get_question_list = dealID => {
  return dispatch => {
    dispatch(request());
    questionService.get_question_list(dealID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: questionConstants.GET_QUESTION_REQUEST, data };
  }
  function success(data) {
    return { type: questionConstants.GET_QUESTION_SUCCESS, data };
  }
  function failure(error) {
    return { type: questionConstants.GET_QUESTION_FAILURE, error };
  }
};

export const delete_question = postData => {
  return dispatch => {
    dispatch(request());
    questionService.delete_question(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: questionConstants.DELETE_QUESTION_REQUEST, data };
  }
  function success(data) {
    return { type: questionConstants.DELETE_QUESTION_SUCCESS, data };
  }
  function failure(error) {
    return { type: questionConstants.DELETE_QUESTION_FAILURE, error };
  }
};

export const get_question_details = quesID => {
  return dispatch => {
    dispatch(request());
    questionService.get_question_details(quesID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: questionConstants.GET_QUESTION_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: questionConstants.GET_QUESTION_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: questionConstants.GET_QUESTION_DETAILS_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/questionActions.js